import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prevPath = useRef('');

  useEffect(() => {
    const fromDetail = /^\/catalogo\/.+/.test(prevPath.current) && pathname === '/catalogo';
    if (!fromDetail) {
      window.scrollTo(0, 0);
    }
    prevPath.current = pathname;
  }, [pathname]);

  return null;
};

export default ScrollToTop;